var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 center-container" }, [
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "hh-brand" }, [_vm._v(" Help Hub ")]),
            _vm._v(" "),
            _c("span", { staticClass: "redirect-normal-container" }, [
              _vm._v("is now ")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "employee-hub-text-container" }, [
              _vm._v("Employee Hub")
            ]),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "redirecting-txt" }, [
              _vm._v(
                "\n                    Redirecting to the new site. . .\n                "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "eh-redirect-border-bottom-container" }, [
              _c("div", { staticClass: "eh-redirect-border-bottom" })
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-805cf89c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-805cf89c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/EmployeeHubRedirect.vue
// module id = null
// module chunks = 